import React from "react";
import CardClass from "../../../CardClass";
import EmptyState from "../../../EmptyState";
import MUIButton from "@mui/material/Button";
import MUIFormControlLabel from "@mui/material/FormControlLabel";
import MUISwitch from "@mui/material/Switch";
import MUIIconButton from "@mui/material/IconButton";
import MUIAddIcon from "@mui/icons-material/Add";
import MUIDeleteIcon from "@mui/icons-material/Delete";
import MUIGrid from "@mui/material/Grid";
import DialogSearchIssueCategory from "../../../Dialog/Search/DialogSearchIssueCategory";
import TileIssueCategory from "../../../Tile/TileIssueCategory";
import PropTypes from "prop-types";
import MainContext from "../../../../Context/MainContext/MainContext";

export default class CardAdminQueueFilterPatientIssueIssueCategory extends CardClass {
    static contextType = MainContext; // For legacy class components

    constructor(props) {
        super(props);

        this.state.issueCategoryDialogOpen = false;
    }

    /**
     * Render the content of the card.
     */
    renderContent() {
        const handleRemove = (issueCategoryId) => {
            const filter = this.props.queue.filter;
            if (!filter["patient_issue.issue_category_id"]?.properties?.value) {
                return;
            }
            filter["patient_issue.issue_category_id"].properties.value = filter["patient_issue.issue_category_id"].properties.value.filter((entry) => entry !== issueCategoryId);
            if (filter["patient_issue.issue_category_id"].properties.value.length === 0) {
                delete filter["patient_issue.issue_category_id"];
            }

            this.props.onChange({
                "filter": filter
            });
        };

        const values = this.props.queue?.filter?.["patient_issue.issue_category_id"]?.properties?.value || [];

        const excludeChecked = this.props.queue?.filter?.["patient_issue.issue_category_id"]?.properties?.operator === "not in";

        const handleExcludeToggle = (event) => {
            const filter = this.props.queue.filter;
            filter["patient_issue.issue_category_id"].properties.operator = event.target.checked ? "not in" : "in";

            this.props.onChange({
                "filter": filter
            });
                };

        if (values.length > 0) {
            return (
                <>
                    <MUIFormControlLabel
                        sx={{ marginLeft: 0 }}
                        control={<MUISwitch color="error" checked={excludeChecked} onChange={handleExcludeToggle} />}
                        label="Exclude"
                    />
                    <MUIGrid container spacing={2}>
                        {values.map((issueCategoryId) => {
                            return (
                                <MUIGrid key={issueCategoryId} item xs={12} sm={6} md={4}>
                                    <TileIssueCategory
                                        issueCategory={this.context.issueCategoriesIndexed[issueCategoryId]}
                                        iconButtons={[(<MUIIconButton onClick={() => handleRemove(issueCategoryId)}><MUIDeleteIcon /></MUIIconButton>)]}
                                    />
                                </MUIGrid>
                            );
                        })}
                        {this.renderDialog()}
                    </MUIGrid>
                </>
            );
        } else {
            return (
                <>
                    <EmptyState
                        line1="Not Configured"
                        line2="Showing all Issue Categories"
                    />
                    {this.renderDialog()}
                </>
            );
        }
    }



    /**
     * Renders a search dialog of Issue Categories
     */
    renderDialog() {
        const handleAdd = (issueCategory) => {
            const filter = (this.props.queue && this.props.queue.filter) || {};
            if (!filter["patient_issue.issue_category_id"]) {
                filter["patient_issue.issue_category_id"] = {
                    type: "set",
                    properties: {
                        operator: "in",
                        value: [],
                    },
                };
            }
            filter["patient_issue.issue_category_id"].properties.value = [...new Set([...(filter["patient_issue.issue_category_id"].properties.value || []), issueCategory.id])];

            this.props.onChange({
                "filter": filter
            });
        };

        return (
            <DialogSearchIssueCategory
                open={this.state.issueCategoryDialogOpen}
                onClose={() => this.setState({ issueCategoryDialogOpen: false })}
                onSelect={handleAdd}
            />
        );
    }

    /**
     * Renders add Issue Category button
     */
    getActions() {
        const handleAdd = () => {
            this.setState({
                issueCategoryDialogOpen: true,
            });
        };

        const buttonItems = [(<MUIButton
                component="label"
                variant="outlined"
                startIcon={<MUIAddIcon />}
                onClick={handleAdd}>Add Issue Category</MUIButton>)
        ];

        return buttonItems;
    }

    /**
     * @returns {string} The title of the card.
     */
    getTitle() {
        return "Filter: Patient Issue > Issue Category";
    }
}